import { captureException, setUser } from '@sentry/react';
import { UserData } from 'noddi-types';
import { castErrorMessageToString, ErrorWithCause, LogInput, logToConsole } from 'noddi-util';

const isProd = import.meta.env.MODE === 'production';

function logToSentry({ value, severity, cause, extra }: LogInput) {
  if (severity === 'debug') {
    return;
  }

  let errorMessage = castErrorMessageToString(value);

  // Enhance error message for network errors
  if (extra?.requestUrl) {
    const method = extra.requestMethod || 'unknown';
    const url = extra.requestUrl;
    errorMessage = `${method.toUpperCase()} ${url} failed: ${errorMessage}`;
  }

  if (cause instanceof Error) {
    captureException(new ErrorWithCause(errorMessage, cause), {
      level: severity,
      extra
    });
  } else {
    if (value instanceof Error) {
      captureException(value, {
        level: severity,
        extra
      });
    } else {
      captureException(errorMessage, {
        level: severity,
        extra
      });
    }
  }
}

function log({ value, severity, cause, extra }: LogInput) {
  if (isProd) {
    logToSentry({ value, severity, cause, extra });
  } else {
    logToConsole({ value, severity, cause });
  }
}

function setSentryUser({ user }: { user: UserData }) {
  if (!isProd) {
    return;
  }

  setUser({ id: user.id.toString(), email: user.email });
}

export { log, setSentryUser };
